module.exports = __webpack_public_path__ + "media/customizations/unionparklife/logo-9f6281b87c3b7dc796c5493691611071.png";